import { Platform } from 'react-native';
import { MentionsInputFieldMobile } from './mentionFieldMobile';
import { MentionsInputFieldWeb } from './mentionFieldWeb';

export type MentionInputFieldProps = {
  inputFieldText: string;
  setInputFieldText: (text: string) => void;
  setIsMultiline: (value: boolean) => void;
  inputHeight: number;
  setInputHeight: (value: number) => void;
  send: () => void;
  suggestionsPosition?: 'top' | 'bottom'; // Position suggestions above or below input
  handleEnter?: boolean;
  useCropCircle?: boolean; // Optional prop to control crop circle redesign
  placeholder?: string;
};

export const MentionInput = (props: MentionInputFieldProps) => {
  const {
    inputFieldText,
    setInputFieldText,
    setIsMultiline,
    inputHeight,
    setInputHeight,
    send,
    suggestionsPosition,
    handleEnter,
    useCropCircle,
    placeholder,
  } = props;

  const isWeb = Platform.OS === 'web';

  const renderMobileMentionInput = () => (
    <MentionsInputFieldMobile
      inputFieldText={inputFieldText}
      setInputFieldText={setInputFieldText}
      setIsMultiline={setIsMultiline}
      inputHeight={inputHeight}
      setInputHeight={setInputHeight}
      suggestionsPosition={suggestionsPosition}
      useCropCircle={useCropCircle}
      placeholder={placeholder}
    />
  );

  const renderWebMentionInput = () => (
    <MentionsInputFieldWeb
      inputFieldText={inputFieldText}
      setInputFieldText={setInputFieldText}
      send={send}
      suggestionsPosition={suggestionsPosition}
      handleEnter={handleEnter}
      useCropCircle={useCropCircle}
      placeholder={placeholder}
    />
  );

  return isWeb ? renderWebMentionInput() : renderMobileMentionInput();
};
